import React from 'react';
export function Header() {
  return <header className="bg-spiritual-900/95 backdrop-blur-md py-4 md:py-5 px-5 md:px-8 sticky top-0 z-50 border-b border-spiritual-400/10" data-id="element-32">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-33">
        <div className="text-spiritual-300 font-heading font-bold text-lg md:text-2xl tracking-wide" data-id="element-34">
          Código de Sanación del Árbol
        </div>
        <a href="#comprar" className="bg-gradient-to-r from-spiritual-400 to-spiritual-500 hover:from-spiritual-500 hover:to-spiritual-400 text-spiritual-900 font-body font-bold px-4 py-2 md:px-6 md:py-2.5 rounded-lg transition-all duration-300 shadow-lg text-sm md:text-base transform hover:scale-105 active:scale-95" data-id="element-35">
          Descargar Ahora
        </a>
      </div>
    </header>;
}